import React from 'react';
import ButtonTheme from '../buttons/Button.Theme';

interface INavbarCommonProps {}

const NavbarCommon = ({}: INavbarCommonProps) => {
  return (
    <div className="flex justify-between items-center py-4 px-3 lg:px-32.5">
      <a
        href="https://das-ar.com"
        target="_blank"
        rel="noreferrer noopener"
        className="font-bold md:text-xl ml-2 rtl:ml-0 rtl:mr-2 self-center text-2xl text-primary whitespace-nowrap">
        DasAR
      </a>
      <ButtonTheme />
    </div>
  );
};

export default React.memo(NavbarCommon);
